var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNavMe = function SvgNavMe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 13A6.5 6.5 0 1 1 8 0a6.5 6.5 0 0 1 0 13Zm-8 4a3 3 0 0 1 3-3h10a3 3 0 0 1 0 6H3c-1.657 0-3-1.346-3-3Z",
    fill: "var(--primaryColor)"
  })));
};

export default SvgNavMe;